import { render } from "./ProductList.vue?vue&type=template&id=0bb2e6d8&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=0bb2e6d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb2e6d8"],['__file',"src/views/h5/crm/product/ProductList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb2e6d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb2e6d8', __exports__)) {
    api.reload('0bb2e6d8', __exports__)
  }
  
  module.hot.accept("./ProductList.vue?vue&type=template&id=0bb2e6d8&scoped=true", () => {
    api.rerender('0bb2e6d8', render)
  })

}


export default __exports__